import AbsComponent from "../../common/AbsComponent";

/**
* MainBanner class
* @category main
*/
class MainBanner extends AbsComponent{
    constructor(_store={}, _el=''){
        super(_store, _el);

        this.charServerType = this.store.data.config.charServerType;
        this.store.getData('mainBanner', {}, this.render.bind(this));
    }

    render(_jsonData = {}) {
        // console.log('render MainBanner ----->', _jsonData);
        $(this.el).append(this.template( _jsonData ));
        this.setting();
        this.addEvents();
    }

    template(_d={}){
        let templ = ''; //템플릿
        let templList = ''; //서버별 아이템 템플릿
        let templListLayer = ''; //서버별 아이템 템플릿
        let itemOrder = []; //서버별 아이템 노출 순서
        _d = JSON.parse(_d.jsonData);
        // 아이템 노출 순서
        if (this.charServerType == "lineage2") {
            itemOrder = _d.orderDefault.split(',')
        } else if (this.charServerType == "lineage2Awakening") {
            itemOrder = _d.orderAwken.split(',')
        } else {
            itemOrder = _d.orderOther.split(',')
        }
        
        // 리스트
        itemOrder.forEach(function(n) {
            //const labels = ;
            templList += `
                <li class="main-banner-item">
                    <a href="${_d.items[n-1].url}" class="main-banner-link ${_d.items[n-1].newBadge ? 'main-banner-new-badge' : ''}" style="background-image:url('${_d.items[n-1].thumbnail}')">
                        <div class="main-banner-inner">
                            <div class="banner-tags">tt
                            ${_d.items[n-1].labels.map(elem => `<span class="banner-tag ${elem.labelType}">${elem.labelTitle}</span>`)}
                            </div>
                            <strong class="banner-title">${_d.items[n-1].title}</strong>
                            <p class="banner-text">${_d.items[n-1].desc}</p>
                            <span class="banner-date">${_d.items[n-1].date}</span>
                        </div>
                    </a>
                </li>
            `

            templListLayer += `
                <li class="layer-item">
                    <a href="${_d.items[n-1].url}" class="layer-link">
                        <span class="layer-thumb" style="background-image:url('${_d.items[n-1].thumbnail}')"></span>
                        <div class="layer-infos">
                            <strong class="layer-title">${_d.items[n-1].title}</strong>
                            <span class="layer-text">${_d.items[n-1].date}</span>
                        </div>
                    </a>
                </li>
            `
        })

        templ = `
            <section class="main-banner">
                <h2 class="blind">메인 배너</h2>
                <ul class="main-banner-list">
                    ${templList}
                </ul>
                <div class="main-banner-pager">
                    <span class="pager-num"><em></em></span>
                    <button type="button" class="pager-showall"><span class="blind">전체 배너 보기</span></button>
                </div>
                <div class="main-banner-layer">
                    <ul class="layer-list">
                      ${templListLayer}
                    </ul>
                    <button type="button" class="btn-close"><span class="blind">닫기</span></button>
                </div>
            </section>
        `;
        return templ;
    }

    setting(){
        $(this.el + ' .main-banner-pager .pager-num').html( "<em>1</em> / " + $(this.el + ' .main-banner-list .main-banner-item').length);

        const slickOption = {
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 4000,
                    settings: {
                        arrows: true
                    }
                },
                {
                    breakpoint: 960,
                    settings: {
                        arrows: false
                    }
                }
            ]
        };
        $(this.el + ' .main-banner-list').slick(slickOption);
    }

    addEvents(){
        $(this.el + ' .main-banner-pager .pager-showall').on("click", (e) => {
            $(this.el + ' .main-banner-layer').addClass('is-active');
        });

        $(this.el + ' .main-banner-layer .btn-close').on("click", (e) => {
            $(this.el + ' .main-banner-layer').removeClass('is-active');
        });

        $(this.el + ' .main-banner-list').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            $(this.el + ' .main-banner-pager .pager-num').html( "<em>" + (nextSlide+1) + "</em> / " + $(this.el + ' .main-banner-layer .layer-list .layer-item').length);
        });
    }

} // end of class
export default MainBanner;